document.addEventListener("DOMContentLoaded", function () {
  const productQuotes = [
    "Es war kein Kauf. Es war ein Moment, der zu mir gepasst hat.",
    "Ich wollte nicht glänzen. Ich wollte wirken – leise, klar, echt.",
    "Ich wusste nicht, dass ein Schmuckstück so viel über mich sagen kann.",
    "Es fühlte sich an wie etwas, das ich schon immer gesucht – aber nie benennen konnte.",
    "Ich trage es nicht, um gesehen zu werden. Ich trage es, weil ich mich darin erkenne.",
    "Jemand sagte: ‚Du strahlst anders.‘ Ich lächelte – und wusste, warum.",
    "Es sagt nichts. Aber es bleibt in Erinnerung.",
    "Ich dachte, ich schenke mir Gold. Aber eigentlich war es Ruhe.",
    "Ich lege es nicht an – ich trete damit in meine Haltung.",
    "Es erzählt etwas über mich, ohne dass ich reden muss.",
    "Es ist kein Schmuckstück. Es ist ein Stück Identität.",
    "Ich habe nicht gesucht – ich habe gespürt, dass es stimmt.",
    "Ich wollte kein Accessoire. Ich wollte ein Zeichen.",
    "Dieses Stück ist leise. Aber es verändert, wie ich mich bewege.",
    "Ich bekomme keine Komplimente für den Preis. Sondern für den Ausdruck.",
    "Es fällt nicht auf – bis es auffällt. Und dann fragt man nicht: Woher? Sondern: Wer bist du?",
    "Man erkennt daran nicht meinen Stil. Sondern mein Wesen.",
    "Ich trage es wie eine Erinnerung – die nur für mich bestimmt ist.",
    "Es war nicht Liebe auf den ersten Blick. Sondern auf den zweiten – den ehrlichen.",
    "Ich dachte, ich wähle es. Aber es hat mich gewählt.",
    "Es erinnert mich an nichts – und doch an alles, was zählt.",
    "Ich kann es nicht erklären. Ich kann es nur fühlen.",
    "Es ist kein Statement. Es ist eine stille Übereinkunft mit mir selbst.",
    "Ich wollte nicht zeigen, was ich habe. Sondern wer ich bin.",
    "Dieses Stück hat keine Geschichte. Bis ich es getragen habe.",
    "Es hat mich nicht angeschrien. Es hat mir zugeflüstert: Du bist angekommen.",
    "Ich wollte nichts Neues. Ich wollte etwas Echtes.",
    "Man fragt mich, woher es ist. Ich antworte: Von mir.",
    "Ich kaufe nicht oft. Aber wenn, dann für immer.",
    "Ich habe es gesehen – und innerlich genickt. Endlich.",
    "Es war kein Impuls. Es war ein innerer Entschluss.",
    "Ich habe nichts gesucht. Aber ich wusste, dass ich es nicht gehen lassen kann.",
    "Es war wie ein leiser Händedruck mit mir selbst.",
    "Das ist kein Schmuck. Das ist meine innere Ruhe in Form.",
    "Es ist nicht laut. Aber es verändert Räume.",
    "Ich habe mich darin erkannt – noch bevor ich es getragen habe.",
    "Es hat keinen Namen. Aber es spricht mich an.",
    "Ich liebe, wie es mich erinnert: Du brauchst nichts ausser dir selbst.",
    "Es verkauft mir nichts. Es bestätigt nur, was ich längst wusste.",
    "Ich trage es nicht, um zu glänzen. Sondern um mich nicht zu vergessen.",
    "Es ist wie ein Mantra ohne Worte.",
    "Wenn jemand fragt, was es bedeutet, weiss ich: Sie würden es nicht verstehen.",
    "Es gehört nicht mir. Es gehört zu mir.",
    "Ich habe vieles getragen. Aber das hat Gewicht – ohne zu drücken.",
    "Es sagt, was ich nicht sagen will. Und doch gehört es zu mir.",
    "Es kostet Geld. Aber was ich bekomme, kann man nicht bezahlen.",
    "Ich trage es nicht, um etwas darzustellen. Ich trage es, weil ich nichts mehr darstellen muss.",
    "Es ist kein Luxus. Es ist Wahrheit in Gold gegossen.",
    "Es sieht nicht teuer aus. Es sieht richtig aus.",
    "Ich muss es nicht erklären. Es erklärt mich."
  ];

 const container = document.getElementById("ziba-quote-text");
  if (!container) return;

  const quote = productQuotes[Math.floor(Math.random() * productQuotes.length)];
  container.innerText = `„${quote}“`;
});





